/**
 * Dev-only traces for “Achats verschwinden nach Reload”.
 * Aktiviert bei NODE_ENV=development.
 */
const ENABLED =
  typeof process !== 'undefined' && process.env.NODE_ENV === 'development';

export function logAchatsReload(phase, payload = {}) {
  if (!ENABLED) return;
  console.log(`[ACHAT·Reload] ${phase}`, {
    ...payload,
    _ts: new Date().toISOString(),
  });
}
